import { Checkbox } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Form, Image, Row } from 'react-bootstrap'
import {
  createSearchParams,
  useNavigate,
  useSearchParams
} from 'react-router-dom'
import ImgCheckbox from '../../../../images/checkbox.svg'
import StapMainLayout from './step-main'
import {
  EMP_CHECK_LIST_DETAIL_ST_4,
  EMP_CHECK_LIST_DETAIL_ST_2
} from '../../../../router/routes'
import {
  BsCheck2,
  BsChevronDoubleLeft,
  BsChevronDoubleRight
} from 'react-icons/bs'
import styled from 'styled-components'
import SwalCustom from '../../../../alert/swal-custom'
import {
  getChecklistNewStepDetailAPI,
  putChecklistNewTwoAPI,
  postChecklistNewTwoITAPI,
  putChecklistUsernameAPI
} from '../../../../services/checklist'
import Error_500 from '../../../error/error-500'
import { useDebounce } from '@react-hook/debounce'
import { getEmpsChkUsernameAPI } from '../../../../services/employee'
import moment from 'moment'
import { TXTSUCCESS } from '../../../../Constants'
import Error_false from '../../../error/error-false'
import InputUsername from '../../../input-username'
import InputPassword from '../../../input-password'
import useNumberInput from '../../../../helper/input-fix-num'
import { BorderColor } from '@mui/icons-material'
import SwalCustomSuccess from '../../../../alert/swal-success'

export default function StapPage2() {
  let [searchParams, setSearchParams] = useSearchParams()
  const status = searchParams.get('status')

  const org = searchParams.get('org')
  const code = searchParams.get('code')
  const clnNo = searchParams.get('id')
  const [detail_1, setDetail_1] = useState([])
  const [detail_2, setDetail_2] = useState([])
  const [detail_3, setDetail_3] = useState([])
  const [detail_4, setDetail_4] = useState([])
  const [detail_5, setDetail_5] = useState([])
  const [isSubmit, setIsSubmit] = useState(false)
  const [approve, setApprove] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [isComputer, setIsComputer] = useState([])
  const [dataStep, setDataStep] = useState([])
  const [createDate, setCreateDate] = useState([])
  const [keyUsername, setKeyUsername] = useDebounce('', 1500)
  const [isUsername, setIsUsername] = useState({ status: true })

  useEffect(() => {
    getStep()
    return () => {}
  }, [])

  useEffect(() => {
    if (keyUsername) {
      getEmpsChkUsername(keyUsername)
    } else {
      setIsUsername({
        status: true
      })
    }
    return () => {}
  }, [keyUsername, org])

  const getEmpsChkUsername = async (searchs) => {
    const data = await getEmpsChkUsernameAPI({
      orgId: org,
      searchs,
      code: code
    })
    if (!data) return
    if (data.status) {
      setIsUsername({
        status: data.result.status,
        ...data.result
      })
    }
  }

  const getStep = async (stepId = 2) => {
    try {
      setIsLoading(true)
      const resp = await getChecklistNewStepDetailAPI({
        stepId,
        clnNo
      })
      setIsLoading(false)
      if (!resp) return
      if (resp.status) {
        setCreateDate(resp.result.insert_date)

        setApprove(resp.result.approve)
        setDataStep(resp.result.result)
        setIsComputer(resp.result.is_computer)
        setDetail_1(
          resp.result.result.length > 0 ? resp.result.result[0].groups : []
        )
        setDetail_2(
          resp.result.result.length > 1 ? resp.result.result[1].groups : []
        )
        setDetail_3(
          resp.result.result.length > 2 ? resp.result.result[2].groups : []
        )
        setDetail_4(
          resp.result.result.length > 3 ? resp.result.result[3].groups : []
        )
        setDetail_5(
          resp.result.result.length > 4 ? resp.result.result[4].groups : []
        )
      } else {
        setDataStep([])
        setDetail_1([])
        setDetail_2([])
        setDetail_3([])
        setDetail_4([])
        setDetail_5([])
      }
    } catch (error) {
      Error_500(error)
    }
  }

  const nevigate = useNavigate()
  const fnBack = () => {
    nevigate(
      {
        pathname: EMP_CHECK_LIST_DETAIL_ST_2,
        search: `?${createSearchParams({
          code,
          org,
          id: clnNo,
          status: status
        })}`
      },
      { replace: true }
    )
  }
  const fnNext = () => {
    nevigate(
      {
        pathname: EMP_CHECK_LIST_DETAIL_ST_4,
        search: `?${createSearchParams({
          code,
          org,
          id: clnNo,
          createDate: createDate,
          status: status
        })}`
      },
      { replace: true }
    )
  }

  //การเตรียมความพร้อมอุปกรณ์ IT
  const fnConfirmDetail_1 = (data) => {
    const body = {
      equipId: dataStep[0].equip_it_group_id,
      equips: [{ id: data.id, detail: data.detail ?? '' }]
    }
    if (data.is_detail === 1 && !data.detail) {
      SwalCustom({
        title: 'ตรวจสอบข้อมูล',
        text: 'โปรดกรอกข้อมูลให้ครบถ้วนก่อนกดยืนยัน',
        confirmButtonColor: '#f9af29',
        showConfirmButton: true
      })
    } else {
      fnSave(body)
    }
  }

  // เปิดสิทธิ์การใช้งานแอปพลิเคชัน
  const fnInputDetail_1 = (event, id) => {
    const { value, checked } = event.target
    if (value || checked) {
      setDetail_1((prev) => {
        const newData = prev.filter((item) => item.id === id)
        return [
          ...[
            {
              ...newData[0],
              is_check: 1,
              detail: value
            }
          ],
          ...prev.filter((item) => item.id !== id)
        ]
      })
    } else {
      setDetail_1((prev) => {
        const newData = prev.filter((item) => item.id === id)
        return [
          ...[
            {
              ...newData[0],
              is_check: 0,
              detail: value
            }
          ],
          ...prev.filter((item) => item.id !== id)
        ]
      })
    }
  }

  //ตั้งค่าเครื่องคอมพิวเตอร์
  const fnConfirmDetail_2 = (data) => {
    const body = {
      equipId: dataStep[1].equip_it_group_id,
      equips: [{ id: data.id, detail: data.detail ?? '' }]
    }
    if (data.is_detail === 1 && !data.detail) {
      SwalCustom({
        title: 'ตรวจสอบข้อมูล',
        text: 'โปรดกรอกข้อมูลให้ครบถ้วนก่อนกดยืนยัน',
        confirmButtonColor: '#f9af29',
        showConfirmButton: true
      })
    } else {
      fnSave(body)
    }
  }
  const fnInputDetail_2 = (event, id) => {
    const { value, checked } = event.target
    if (value || checked) {
      setDetail_2((prev) => {
        const newData = prev.filter((item) => item.id === id)
        return [
          ...[
            {
              ...newData[0],
              is_check: 1,
              detail: value
            }
          ],
          ...prev.filter((item) => item.id !== id)
        ]
      })
    } else {
      setDetail_2((prev) => {
        const newData = prev.filter((item) => item.id === id)
        return [
          ...[
            {
              ...newData[0],
              is_check: 0,
              detail: value
            }
          ],
          ...prev.filter((item) => item.id !== id)
        ]
      })
    }
  }

  //ซอฟต์แวร์
  const handleCheckList_3 = (event, id) => {
    const { checked } = event.target
    if (checked) {
      setDetail_3((prev) => {
        const newData = prev.filter((item) => item.id === id)
        return [
          ...[
            {
              ...newData[0],
              is_check: 1,
              detail: ''
            }
          ],
          ...prev.filter((item) => item.id !== id)
        ]
      })
    } else {
      setDetail_3((prev) => {
        const newData = prev.filter((item) => item.id === id)
        return [
          ...[
            {
              ...newData[0],
              is_check: 0,
              detail: ''
            }
          ],
          ...prev.filter((item) => item.id !== id)
        ]
      })
    }
  }

  const fnConfirmDetail_3 = () => {
    const isCheck = detail_3.filter((d) => d.is_check === 1)
    const num = detail_3.map((d) => d.is_check).reduce((a, b) => a + b, 0)

    if (num === detail_3.length) {
      const body = {
        equipId: dataStep[2].equip_it_group_id,
        equips: isCheck
      }
      fnSave(body)
    } else {
      SwalCustom({
        title: 'ตรวจสอบข้อมูล',
        text: 'โปรดตรวจสอบข้อมูลให้ครบถ้วน',
        confirmButtonColor: '#f9af29',
        showConfirmButton: true
      })
    }
  }

  // การเตรียมความพร้อมด้านการใช้งานระบบ IT
  const fnInputDetail_4 = (d, target) => {
    let value = target.value
    if (d.id === 15) {
      setKeyUsername(value)
    }

    setDetail_4((prev) => {
      const newData = prev.filter((item) => item.id === d.id)
      return [
        ...[
          {
            ...newData[0],
            is_check: d.is_detail ? (value ? 1 : 0) : d.is_check ? 0 : 1,
            detail: d.is_detail ? value : ''
          }
        ],
        ...prev.filter((item) => item.id !== d.id)
      ]
    })
  }

  // เปิดสิทธิ์การใช้งานแอปพลิเคชัน
  const fnInputDetail_5 = (id, value) => {
    if (value) {
      setDetail_5((prev) => {
        const newData = prev.filter((item) => item.id === id)
        return [
          ...[
            {
              ...newData[0],
              is_check: 1,
              detail: value
            }
          ],
          ...prev.filter((item) => item.id !== id)
        ]
      })
    } else {
      setDetail_5((prev) => {
        const newData = prev.filter((item) => item.id === id)
        return [
          ...[
            {
              ...newData[0],
              is_check: 0,
              detail: ''
            }
          ],
          ...prev.filter((item) => item.id !== id)
        ]
      })
    }
  }

  // IT (big)
  const fnConfirmDetail_4 = () => {
    const notLarkNum = detail_4
      .map((d) => d.is_check && ![38, 39, 40].includes(d.id))
      .reduce((a, b) => a + b, 0)
    const larkNum = detail_4
      .map((d) => d.is_check && [38, 39, 40].includes(d.id))
      .reduce((a, b) => a + b, 0)

    const check = notLarkNum === detail_4.length - 3 && larkNum === 1

    if (isUsername.status) {
      if (check) {
        const body = {
          equipId: dataStep[3].equip_it_group_id,
          equips: detail_4
            .filter((d) => d.is_check)
            .map((d) => {
              return { id: d.id, detail: d.detail }
            })
        }
        fnSave(body)
      } else {
        SwalCustom({
          title: 'ตรวจสอบข้อมูล',
          text: 'โปรดกรอกข้อมูล ชื่อผู้ใช้ รหัสผ่าน อีเมล และประเภท Lark ให้ถูกต้องครบถ้วน',
          confirmButtonColor: '#f9af29',
          showConfirmButton: true
        })
      }
    } else {
      SwalCustom({
        title: 'ชื่อผู้ใช้นี้มีในระบบแล้ว!',
        text: 'ไม่สามารถใช้ชื่อผู้ใช้นี้ โปรดใช้ชื่ออื่น',
        confirmButtonColor: '#f9af29',
        showConfirmButton: true
      })
    }
  }

  // APP (big)
  const fnConfirmDetail_5 = () => {
    const num = detail_5.map((d) => d.is_check).reduce((a, b) => a + b, 0)
    if (num === detail_5.length) {
      const body = {
        equipId: dataStep[4].equip_it_group_id,
        equips: detail_5.map((d) => {
          return { id: d.id, detail: d.detail }
        })
      }
      fnSave(body)
    } else {
      SwalCustom({
        title: 'ตรวจสอบข้อมูล',
        text: 'โปรดกรอกข้อมูล Mango และ Portal ให้ครบถ้วน',
        confirmButtonColor: '#f9af29',
        showConfirmButton: true
      })
    }
  }

  const fnSave = async (body) => {
    try {
      setIsLoading(true)

      setIsSubmit(true)
      const param = { clnNo }

      const resp = await putChecklistNewTwoAPI(param, body)
      setIsLoading(false)

      setIsSubmit(false)
      if (!resp) return
      if (resp.status) {
        SwalCustomSuccess().then(() => {
          getStep()
        })
      } else {
        Error_false(resp)
      }
    } catch (error) {
      Error_500(error)
    }
  }

  const onSubmit = () => {
    const param = { clnNo }
    SwalCustom({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: '#2C5DFE',

      confirmButtonText: 'Submit'
    }).then((result) => {
      if (result.isConfirmed) {
        fnSave2(param)
      }
    })
  }

  const fnSave2 = async (body) => {
    try {
      setIsLoading(true)
      const param = { clnNo }
      const resp = await postChecklistNewTwoITAPI(param)
      setIsSubmit(false)
      setIsLoading(false)
      if (!resp) return
      if (resp.status) {
        SwalCustomSuccess().then(() => {
          getStep()
        })
      } else {
        Error_false(resp)
      }
    } catch (error) {
      Error_500(error)
    }
  }
  const inputRef = useRef(null)

  const handleKeyDownNum = useNumberInput(inputRef)
  const [isLoadingRename, setIsLoadingRename] = useState(false)
  const fnRenameUsername = async () => {
    setIsLoadingRename(true)
    const resp = await putChecklistUsernameAPI({
      oldUsername: isUsername.username,
      currentCode: code
    })
    setIsLoadingRename(false)
    if (!resp) return
    if (resp.status) {
      getEmpsChkUsername(isUsername.username)
      SwalCustomSuccess()
    }
  }
  return (
    <Row>
      {isLoading && <div className="preloader"></div>}

      <Col
        xl={12}
        className="mt-3 mb-3"
        style={{ position: 'sticky', top: 0, zIndex: 1000 }}
      >
        <StapMainLayout current={2} />
      </Col>

      <div className="mt-2 mb-3">
        <span className="fw-bold ">เลขเอกสาร: </span>
        <span className="">{clnNo} </span>
        <span className="fw-light me-2">
          {createDate ? moment(createDate).format('DD/MM/YYYY HH:mm') : ''}
        </span>
      </div>
      <Col xl={12}>
        <div className="fw-bold mb-2 ">
          {dataStep.length > 0 && dataStep[0].equip_it_group}
        </div>

        {detail_1.length > 0 &&
          detail_1
            .sort((a, b) => a.id - b.id)
            .map((d, i) => (
              <Row className="mb-3" key={i}>
                <Col md={5}>
                  <Checkbox.Group>
                    <CheckboxCustom className="fw-light">
                      {d.is_detail === 1 ? (
                        <div
                          className="form-check mb-3 d-flex"
                          key={`${d}-${i}`}
                        >
                          <input
                            checked={d.is_check === 1 ? true : false}
                            // disabled
                            name={`detail_1-checkbox-${i}`}
                            id={`detail_1-checkbox-${i}`}
                            type="checkbox"
                            className="form-check-input"
                          />
                          <div className="form-check-label">
                            <label for={`detail_1-checkbox-${i}`}>
                              {d.equip_it_name}
                            </label>
                            <div
                              style={{ marginLeft: '15px', maxWidth: '150px' }}
                            >
                              {approve ? (
                                <Form.Control
                                  name="ExtensionNumber"
                                  disabled={true}
                                  value={d.detail}
                                />
                              ) : (
                                <Form.Control
                                  name="ExtensionNumber"
                                  disabled={
                                    d.is_check === 1 && d.confirm_date
                                      ? true
                                      : false
                                  }
                                  value={d.detail}
                                  onChange={(e) => fnInputDetail_1(e, d.id)}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <Form.Check
                          checked={d.is_check === 0 ? false : true}
                          label={d.equip_it_name}
                          name={`description1`}
                          type="checkbox"
                          className="mb-3 d-flex"
                        />
                      )}
                    </CheckboxCustom>
                  </Checkbox.Group>
                </Col>
                <Col md={7}>
                  <div className="d-flex" style={{ columnGap: '16px' }}>
                    {approve ? (
                      <></>
                    ) : (
                      <Button
                        size="sm"
                        style={{ minWidth: 110 }}
                        disabled={
                          d.is_check === 1 && d.confirm_date ? true : false
                        }
                        className="rounded-3"
                        onClick={() => {
                          fnConfirmDetail_1(d)
                        }}
                      >
                        <BsCheck2 size={18} className="me-1" /> Confirm
                      </Button>
                    )}
                    <BoxName className="rounded-3">
                      {d.name_th} {d.surname_th}{' '}
                      {d.confirm_date
                        ? moment(d.confirm_date).format('DD/MM/YYYY')
                        : ''}
                    </BoxName>
                  </div>
                </Col>
              </Row>
            ))}
      </Col>

      {isComputer === true ? (
        <Col xl={12}>
          <div className="fw-bold mb-2 ">
            {dataStep.length > 1 && dataStep[1].equip_it_group}
          </div>

          {detail_2.length > 0 &&
            detail_2
              .sort((a, b) => a.id - b.id)
              .map((d, i) => (
                <Row className="mb-3" key={`set-com${i}`}>
                  <Col md={5}>
                    <Checkbox.Group>
                      <CheckboxCustom className="fw-light">
                        {d.is_detail === 1 ? (
                          <div className="form-check mb-3" key={`${d}-${i}`}>
                            <input
                              checked={d.is_check === 1 ? true : false}
                              name={`description1`}
                              type="checkbox"
                              id={`inline-checkbox-${i}`}
                              className="form-check-input"
                            />
                            <div className="form-check-label">
                              <label htmlFor={`checkbox-radio-${i}`}>
                                {d.equip_it_name}
                              </label>
                              <div
                                style={{
                                  marginLeft: '35px',
                                  maxWidth: '150px'
                                }}
                              >
                                <Form.Control
                                  disabled={
                                    d.is_check === 1 && d.confirm_date
                                      ? true
                                      : false
                                  }
                                  name="ITAsset"
                                  value={d.detail}
                                  onChange={(e) => fnInputDetail_2(e, d.id)}
                                />
                              </div>
                            </div>
                          </div>
                        ) : (
                          <Form.Check
                            defaultChecked={d.is_check === 0 ? false : true}
                            checked={d.is_check === 0 ? false : true}
                            label={d.equip_it_name}
                            name={`description1`}
                            type="checkbox"
                            className="mb-3"
                          />
                        )}
                      </CheckboxCustom>
                    </Checkbox.Group>
                  </Col>

                  <Col md={7}>
                    <div className="d-flex" style={{ columnGap: '16px' }}>
                      {approve ? (
                        <></>
                      ) : (
                        <Button
                          size="sm"
                          style={{ minWidth: 120 }}
                          disabled={
                            d.is_check === 1 && d.confirm_date ? true : false
                          }
                          className="rounded-3"
                          onClick={() => fnConfirmDetail_2(d)}
                        >
                          <BsCheck2 size={18} className="me-1" /> Confirm
                        </Button>
                      )}
                      <BoxName className="rounded-3">
                        {' '}
                        {d.name_th} {d.surname_th}{' '}
                        {d.confirm_date
                          ? moment(d.confirm_date).format('DD/MM/YYYY')
                          : ''}
                      </BoxName>
                    </div>
                  </Col>
                </Row>
              ))}
        </Col>
      ) : (
        <></>
      )}

      {isComputer === true ? (
        <Col xl={12}>
          <div className="fw-bold mb-2 ">
            {' '}
            {dataStep.length > 2 && dataStep[2].equip_it_group}
          </div>

          <Checkbox.Group>
            <CheckboxCustom className="fw-light">
              {detail_3.length > 0 &&
                detail_3
                  .sort((a, b) => a.id - b.id)
                  .map((d, i) => (
                    <Form.Check
                      checked={d.is_check === 1 ? true : false}
                      key={`set-softwear${i}`}
                      label={d.equip_it_name}
                      name={`description`}
                      type="checkbox"
                      className="mb-3"
                      value={d.id}
                      onChange={(e) =>
                        !dataStep[2].approve && handleCheckList_3(e, d.id)
                      }
                    />
                  ))}
            </CheckboxCustom>
          </Checkbox.Group>
        </Col>
      ) : (
        <></>
      )}

      {!isComputer ? (
        <></>
      ) : (
        <Col xl={12} className="text-center mt-5 mb-5 ">
          {dataStep.length > 2 && dataStep[2].approve ? (
            <div className=" mt-5 font-small-2 d-flex justify-content-center">
              <div style={{ width: 300 }}>
                <div className="d-flex justify-content-center">
                  <Image width={250} fluid src={dataStep[2].approve.url} />
                </div>
                <div className="d-flex justify-content-center">
                  ลงชื่อ
                  <div
                    style={{
                      borderBottom: '1px dashed rgb(135, 135, 135)',
                      width: 200
                    }}
                  ></div>{' '}
                  ผู้ดำเนินการ
                </div>
                <div className="d-flex justify-content-center mt-3">
                  ({dataStep[2].approve.title_th} {dataStep[2].approve.name_th}{' '}
                  {dataStep[2].approve.surname_th})
                </div>
                <div className="d-flex justify-content-center fw-light mt-1">
                  {dataStep[2].approve.position_th}
                </div>
                <div className="d-flex justify-content-center fw-light">
                  {moment(dataStep[2].approve.confirm_date).format(
                    'DD/MM/YYYY'
                  )}
                </div>
              </div>
            </div>
          ) : (
            <Button
              className="rounded-3"
              style={{ minWidth: 150 }}
              onClick={fnConfirmDetail_3}
            >
              <BsCheck2 size={18} className="me-1" /> Confirm
            </Button>
          )}
        </Col>
      )}

      {/* การเตรียมความพร้อมด้านการใช้งานระบบ */}
      <Col xl={12}>
        <div className="fw-bold mb-2 ">
          {dataStep.length > 3 && dataStep[3].equip_it_group}
        </div>

        <Checkbox.Group>
          <CheckboxCustom className="fw-light">
            {detail_4.length > 0 &&
              detail_4
                .sort((a, b) => a.id - b.id)
                .map((d, i) => (
                  <div className="form-check mb-3" key={d + i}>
                    <input
                      // disabled={dataStep[3].approve}
                      checked={d.is_check === 1 ? true : false}
                      name={`group4`}
                      type="checkbox"
                      id={`inline-group4-${i}`}
                      className="form-check-input"
                      onChange={(e) => {
                        if (!d.is_detail) {
                          fnInputDetail_4(d, e.target)
                        }
                      }}
                    />
                    <div className="form-check-label">
                      <label htmlFor={`inline-group4-${i}`}>
                        {d.equip_it_name}
                      </label>
                      <div style={{ marginLeft: '35px', minWidth: '300px' }}>
                        {d.id === 17 ? (
                          <Form.Control
                            type={'email'}
                            onChange={(e) => {
                              fnInputDetail_4(d, e.target)
                            }}
                            disabled={dataStep[3].approve}
                            className={`${
                              d.id === 15 &&
                              !isUsername.status &&
                              'border-danger text-danger'
                            }`}
                            value={d.detail}
                          />
                        ) : d.id === 16 ? (
                          <>
                            <InputPassword
                              onChange={(e) => {
                                fnInputDetail_4(d, e.target)
                              }}
                              disabled={dataStep[3].approve}
                              className={`${
                                d.id === 15 &&
                                !isUsername.status &&
                                'border-danger text-danger'
                              }`}
                              value={d.detail}
                            />
                            <p
                              className="text-muted"
                              style={{ fontSize: '11px' }}
                            >
                              Pattern: A-Z a-z 0-9 . _ @ ! * #
                            </p>
                          </>
                        ) : d.id === 15 ? (
                          <>
                            <>
                              <div className="d-flex">
                                <InputUsername
                                  onChange={(e) => {
                                    fnInputDetail_4(d, e.target)
                                  }}
                                  disabled={dataStep[3].approve}
                                  style={{
                                    borderColor: !isUsername.status ? 'red' : ''
                                  }}
                                  className={`${
                                    d.id === 15 &&
                                    !isUsername.status &&
                                    ' text-danger'
                                  }`}
                                  value={d.detail}
                                />
                                {!isUsername.status && (
                                  <Button
                                    onClick={() => {
                                      SwalCustom({
                                        title: 'ยืนยันการเปลี่ยนชื่อผู้ใช้?',
                                        text: 'โปรดตรวจสอบให้แน่ใจก่อนกดยืนยัน',
                                        icon: 'warning',
                                        showCancelButton: true,
                                        confirmButtonColor: '#3085d6',
                                        cancelButtonColor: '#d33',
                                        confirmButtonText: 'ยืนยัน',
                                        cancelButtonText: 'ยกเลิก'
                                      }).then((result) => {
                                        if (result.isConfirmed) {
                                          fnRenameUsername()
                                        }
                                      })
                                    }}
                                    variant="danger"
                                    className="ms-2"
                                    disabled={
                                      isLoadingRename || dataStep[3].approve
                                    }
                                  >
                                    {isLoadingRename ? 'Renaming...' : 'Rename'}
                                  </Button>
                                )}
                              </div>
                              <p
                                className="text-muted"
                                style={{ fontSize: '11px' }}
                              >
                                Pattern: a-z 0-9 . _
                              </p>
                            </>
                          </>
                        ) : d.id === 10 ? (
                          <>
                            {d.is_detail === 1 ? (
                              <>
                                <Form.Control
                                  onChange={(e) => {
                                    fnInputDetail_4(d, e.target)
                                  }}
                                  disabled={dataStep[3].approve}
                                  className={`${
                                    d.id === 15 &&
                                    !isUsername.status &&
                                    'border-danger text-danger'
                                  }`}
                                  value={d.detail}
                                  onKeyDown={handleKeyDownNum}
                                />
                              </>
                            ) : (
                              <></>
                            )}
                          </>
                        ) : (
                          <>
                            {d.is_detail === 1 ? (
                              <>
                                <Form.Control
                                  onChange={(e) => {
                                    fnInputDetail_4(d, e.target)
                                  }}
                                  disabled={dataStep[3].approve}
                                  className={`${
                                    d.id === 15 &&
                                    !isUsername.status &&
                                    'border-danger text-danger'
                                  }`}
                                  value={d.detail}
                                />
                              </>
                            ) : (
                              <></>
                            )}
                          </>
                        )}
                      </div>
                      {d.id === 15 && !isUsername.status && (
                        <div
                          style={{
                            marginLeft: '35px',
                            fontSize: '13px',
                            color: '#e74747'
                          }}
                        >
                          ชื่อผู้ใช้นี้มีในระบบแล้ว คือ{' '}
                          {isUsername.full_name ?? '...'}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
          </CheckboxCustom>
        </Checkbox.Group>
      </Col>
      <Col xl={12} className="text-center mt-5 mb-5">
        {dataStep.length > 3 && dataStep[3].approve ? (
          <div className=" mt-5 font-small-2 d-flex justify-content-center">
            <div style={{ width: 300 }}>
              <div className="d-flex justify-content-center">
                <Image width={250} fluid src={dataStep[3].approve.url} />
              </div>
              <div className="d-flex justify-content-center">
                ลงชื่อ
                <div
                  style={{
                    borderBottom: '1px dashed rgb(135, 135, 135)',
                    width: 200
                  }}
                ></div>{' '}
                ผู้ดำเนินการ
              </div>
              <div className="d-flex justify-content-center mt-3">
                ({dataStep[3].approve.title_th} {dataStep[3].approve.name_th}{' '}
                {dataStep[3].approve.surname_th})
              </div>
              <div className="d-flex justify-content-center fw-light mt-1">
                {dataStep[3].approve.position_th}
              </div>
              <div className="d-flex justify-content-center fw-light">
                {moment(dataStep[3].approve.confirm_date).format('DD/MM/YYYY')}
              </div>
            </div>
          </div>
        ) : (
          <Button
            className="rounded-3"
            style={{ minWidth: 150 }}
            onClick={fnConfirmDetail_4}
          >
            <BsCheck2 size={18} className="me-1" /> Confirm
          </Button>
        )}
      </Col>
      <Col xl={12}>
        <div className="fw-bold mb-2 ">
          {' '}
          {dataStep.length > 4 && dataStep[4].equip_it_group}
        </div>

        <Checkbox.Group>
          <CheckboxCustom className="fw-light">
            {detail_5.length > 0 &&
              detail_5
                .sort((a, b) => a.id - b.id)
                .map((d, i) => (
                  <div className="form-check mb-3" key={`${d}-${i}`}>
                    <input
                      name={`group5`}
                      type="checkbox"
                      id={`inline-checkbox-${i}`}
                      className="form-check-input"
                      readOnly
                      checked={d.is_check === 1 ? true : false}
                    />
                    <div className="form-check-label">
                      <label htmlFor={`checkbox-radio-${i}`}>
                        {d.equip_it_name}
                      </label>
                      <div style={{ marginLeft: '35px' }}>
                        <Form.Control
                          value={d.detail}
                          disabled={dataStep.length > 4 && dataStep[4].approve}
                          onChange={(e) => {
                            fnInputDetail_5(d.id, e.target.value)
                          }}
                        />
                      </div>
                    </div>
                  </div>
                ))}
          </CheckboxCustom>
        </Checkbox.Group>

        {/* Button Confirm */}

        {dataStep.length > 4 && dataStep[4].approve ? (
          <div className=" mt-5 font-small-2 d-flex justify-content-center">
            <div style={{ width: 300 }}>
              <div className="d-flex justify-content-center">
                <Image width={250} fluid src={dataStep[4].approve.url} />
              </div>
              <div className="d-flex justify-content-center">
                ลงชื่อ
                <div
                  style={{
                    borderBottom: '1px dashed rgb(135, 135, 135)',
                    width: 200
                  }}
                ></div>{' '}
                ผู้ดำเนินการ
              </div>
              <div className="d-flex justify-content-center mt-3">
                ({dataStep[4].approve.title_th} {dataStep[4].approve.name_th}{' '}
                {dataStep[4].approve.surname_th})
              </div>
              <div className="d-flex justify-content-center fw-light mt-1">
                {dataStep[4].approve.position_th}
              </div>
              <div className="d-flex justify-content-center fw-light">
                {moment(dataStep[4].approve.confirm_date).format('DD/MM/YYYY')}
              </div>
            </div>
          </div>
        ) : (
          <div className="d-flex justify-content-center">
            <Button
              className="rounded-3"
              style={{ minWidth: 150 }}
              disabled={isSubmit}
              onClick={fnConfirmDetail_5}
            >
              <BsCheck2 size={18} className="me-1" /> Confirm
            </Button>
          </div>
        )}
      </Col>
      {approve ? (
        <div className=" mt-5 font-small-2 d-flex justify-content-center">
          <div style={{ width: 300 }}>
            <div className="d-flex justify-content-center">
              <Image width={250} fluid src={approve.url} />
            </div>
            <div className="d-flex justify-content-center">
              ลงชื่อ
              <div
                style={{
                  borderBottom: '1px dashed rgb(135, 135, 135)',
                  width: 200
                }}
              ></div>{' '}
              ผู้ดำเนินการ
            </div>
            <div className="d-flex justify-content-center mt-3">
              ({approve.title_th} {approve.name_th} {approve.surname_th})
            </div>
            <div className="d-flex justify-content-center fw-light mt-1">
              {approve.position_th}
            </div>
            <div className="d-flex justify-content-center fw-light">
              {moment(approve.confirm_date2).format('DD/MM/YYYY')}
            </div>
          </div>
        </div>
      ) : (
        <Col xl={12} className="mt-5 text-center">
          {(detail_1[0]?.is_check === 1 &&
            dataStep[2]?.approve &&
            dataStep[3]?.approve &&
            dataStep[4]?.approve &&
            isComputer) ||
          (!isComputer &&
            detail_1[0]?.is_check === 1 &&
            dataStep[3]?.approve &&
            dataStep[4]?.approve) ? (
            <Button
              className="px-5 rounded-3"
              disabled={isSubmit}
              onClick={onSubmit}
            >
              {isSubmit ? 'Submitting...' : 'Submit'}
            </Button>
          ) : (
            <></>
          )}
        </Col>
      )}

      <div
        className="d-flex justify-content-between mt-5 mb-3 pe-4 bg-white"
        style={{ position: 'sticky', bottom: 0, zIndex: 1000 }}
      >
        <span className=" border-0 small p-3  pointer-event" onClick={fnBack}>
          <BsChevronDoubleLeft className="me-2 " />
          Back
        </span>
        {approve && (
          <span className=" border-0 small p-3  pointer-event" onClick={fnNext}>
            Next
            <BsChevronDoubleRight className="ms-2 " />
          </span>
        )}
      </div>
    </Row>
  )
}
const CheckboxCustom = styled.div`
  .form-check-inline {
    display: inline-block;
    margin-right: 3px;
  }

  .form-check-input[type='radio'] {
    margin-top: auto !important;
    margin-bottom: auto !important;
    border-radius: 4px;
    background-image: url(${ImgCheckbox}) !important;
  }
  .form-check-input:checked {
    background-color: 'var(--comp-badge-color-background-primary)' !important;
  }
  .form-check-input {
    width: 1.5em;
    height: 1.5em;
    border: 1px solid 'var(--comp-badge-color-background-primary)';
    border: 1px solid #2c5dfe;
  }
  .form-check .form-check-input {
    float: left;
    margin-right: 1em;
    margin-left: 0em;
    margin-top: 0em;
  }
`
const BoxName = styled.div`
  font-size: 13px;
  min-width: 300px;
  background-color: #e3e3e3;
  border: 1px solid #e6e6e6;
  opacity: 0.5;
  height: 35px;
  padding: 0.375rem 0.75rem;
`
